import { EditorContent } from '@tiptap/react';
import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React, { useCallback } from 'react';
import _Icon from '../../components/Icon/index.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var TextEditorContainer = styled__default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: white;\n    border: 2px solid #eee;\n    padding: 1rem;\n\n    &&& .tableWrapper {\n        margin: 1.5rem 0;\n        overflow-x: auto;\n        table {\n            margin-left: 1rem;\n            margin-right: 1rem;\n            border-collapse: collapse;\n            overflow: hidden;\n            table-layout: fixed;\n            width: 100%;\n            td,\n            th {\n                border: 1px solid #ccc;\n                box-sizing: border-box;\n                min-width: 1em;\n                padding: 6px 8px;\n                position: relative;\n                vertical-align: top;\n\n            > * {\n                margin-bottom: 0;\n            }\n        }\n\n        th {\n            background-color: #f9f9f9;\n            font-weight: bold;\n            text-align: left;\n        }\n\n        .selectedCell:after {\n            background: #ccc;\n            content: \"\";\n            left: 0; right: 0; top: 0; bottom: 0;\n            pointer-events: none;\n            position: absolute;\n            z-index: 2;\n        }\n\n            .column-resize-handle {\n                background-color: purple;\n                bottom: -2px;\n                pointer-events: none;\n                position: absolute;\n                right: -2px;\n                top: 0;\n                width: 4px;\n            }\n        }\n    }\n"])));
var TextEditorPreviewContainer = styled__default(TextEditorContainer)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: none;\n    padding: 0;\n    &&& .tableWrapper {\n        table {\n            margin: 0;\n        }\n    }\n"])));
var StyledControlGroup = styled__default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 1rem;\n"])));
var StyledButton = styled__default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    background: ", ";\n    border: ", ";;\n    height: 32px;\n    width: 32px;\n    &:hover {\n        cursor: pointer;\n    }\n    i:before {\n        color: ", ";\n    }\n    margin-right: 0.5rem;\n    margin-bottom: 0.5rem;\n"])), function (_ref) {
  var active = _ref.active;
  return active ? '#333' : 'white';
}, function (_ref2) {
  var active = _ref2.active;
  return active ? 'none' : '1px solid #333';
}, function (_ref3) {
  var active = _ref3.active;
  return active ? 'white' : '#333';
});
// styled-components 5.0.0 fixes this (as any) issue
var StyledTextButton = styled__default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    background: #fff;\n    border: 1px solid #ccc;\n    &:disabled {\n        border: 1px solid #eee;\n    }\n    padding: 0.5rem;\n    &:hover {\n        cursor: pointer;\n        &:disabled {\n            cursor: not-allowed;\n        }\n    }\n    margin-right: 0.5rem;\n    margin-bottom: 0.5rem;\n"])));
var TextEditorMenu = function TextEditorMenu(_ref4) {
  var editor = _ref4.editor,
    isTableEditor = _ref4.isTableEditor;
  if (!editor) {
    return null;
  }
  var setLink = useCallback(function () {
    var previousUrl = editor.getAttributes('link').href;
    var url = window.prompt('URL', previousUrl);
    // cancelled
    if (url === null) {
      return;
    }
    // empty
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run();
      return;
    }
    // update link
    editor.chain().focus().extendMarkRange('link').setLink({
      href: url
    }).run();
  }, [editor]);
  return /*#__PURE__*/React.createElement(StyledControlGroup, null, /*#__PURE__*/React.createElement("div", {
    className: "button-group"
  }, /*#__PURE__*/React.createElement(StyledButton, {
    title: "Bold",
    active: editor.isActive('bold'),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleBold().run();
    },
    disabled: !editor.can().chain().focus().toggleBold().run()
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "bold",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Italic",
    active: editor.isActive('italic'),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleItalic().run();
    },
    disabled: !editor.can().chain().focus().toggleItalic().run()
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "italic",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Underline",
    active: editor.isActive('underline'),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleUnderline().run();
    },
    disabled: !editor.can().chain().focus().toggleUnderline().run()
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "underline",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Strike",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleStrike().run();
    },
    disabled: !editor.can().chain().focus().toggleStrike().run()
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "strikethrough",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Heading 1",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleHeading({
        level: 1
      }).run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "one",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Heading 2",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleHeading({
        level: 2
      }).run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "two",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Bullet List",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleBulletList().run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "list-ul",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Ordered List",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleOrderedList().run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "list-ol",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Align Left",
    active: editor.isActive({
      textAlign: 'left'
    }),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().setTextAlign('left').run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "align-left",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Align Center",
    active: editor.isActive({
      textAlign: 'center'
    }),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().setTextAlign('center').run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "align-center",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Align Right",
    active: editor.isActive({
      textAlign: 'right'
    }),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().setTextAlign('right').run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "align-right",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Align Justify",
    active: editor.isActive({
      textAlign: 'justify'
    }),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().setTextAlign('justify').run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "align-justify",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Blockquote",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().toggleBlockquote().run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "quote-left",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Add Link",
    active: editor.isActive('link'),
    onClick: function onClick(e) {
      e.preventDefault();
      setLink();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "add-link",
    size: "xs"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    title: "Remove Link",
    active: !editor.isActive('link'),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().unsetLink().run();
    }
  }, /*#__PURE__*/React.createElement(_Icon, {
    name: "add-link-slash",
    size: "xs"
  })), isTableEditor && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Insert Table",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().insertTable({
        rows: 3,
        cols: 3,
        withHeaderRow: true
      }).run();
    }
  }, "Insert Table"), /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Add row after",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().addRowAfter().run();
    },
    disabled: !editor.can().addRowAfter()
  }, "Add row after"), /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Add row before",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().addRowBefore().run();
    },
    disabled: !editor.can().addRowBefore()
  }, "Add row before"), /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Add column after",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().addColumnAfter().run();
    },
    disabled: !editor.can().addColumnAfter()
  }, "Add column after"), /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Add column before",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().addColumnBefore().run();
    },
    disabled: !editor.can().addColumnBefore()
  }, "Add column before"), /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Delete row",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().deleteRow().run();
    },
    disabled: !editor.can().deleteRow()
  }, "Delete row"), /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Delete column",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().deleteColumn().run();
    },
    disabled: !editor.can().deleteColumn()
  }, "Delete column"), /*#__PURE__*/React.createElement(StyledTextButton, {
    title: "Delete table",
    onClick: function onClick(e) {
      e.preventDefault();
      editor.chain().focus().deleteTable().run();
    },
    disabled: !editor.can().deleteTable()
  }, "Delete table"))));
};
var StyledEditorContent = styled__default(EditorContent)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    box-shadow: 0 -3px 0 #ddd;\n    padding: 1rem 0.75rem 0 1rem;\n    border: 2px solid #eee;\n    border-top: none;\n    ul, ol {\n        list-style-position: outside;\n        padding: 0 1rem;\n        margin: 1.25rem 1rem 1.25rem 0.4rem;\n    }\n    li {\n        &::before {\n            display: none;\n        }\n    }\n"])));
var TextEditor = function TextEditor(_ref5) {
  var editor = _ref5.editor;
  return /*#__PURE__*/React.createElement(StyledEditorContent, {
    editor: editor
  });
};

export { TextEditor, TextEditorContainer, TextEditorMenu, TextEditorPreviewContainer };
